export default window.clientConfig || {};
